













































































































import {Component, Vue, Prop} from 'vue-property-decorator';
import {Action, Getter, State} from 'vuex-class';
import BasicInfo from './BasicInfo.vue';
import Configure from './Configure/Index.vue';
import CoverageDetails from './CoverageDetails.vue';
import Verification from './Verification.vue';
import Summary from './Summary.vue';
import Payment from './Payment.vue';
import EventBus from '@/common/EventBus';
import ConfigSummary from './Configure/ConfigSummary.vue';
import _ from 'lodash';
import Util from '@/utils/Util';
import {CMSContentService} from '@/services/CMSService';
import {FactService} from '@/services/FactService';
import { IQuotation } from '@/interfaces';
import WorkflowService from '@/services/WorkflowService';

@Component({
  name: 'PortalStepperItems',
  components: {
    BasicInfo,
    Configure,
    CoverageDetails,
    Verification,
    Summary,
    Payment,
    ConfigSummary
  }
})
export default class PortalStepperItems extends Vue {
  @State private app: any;
  @State private cms: any;
  @State private proposal: any;
  @State private quotation!: IQuotation;
  @Prop() private value!: string;
  @Prop() private steps!: any;
  @Prop() private step!: any;
  @Prop() private afterUW!: boolean;
  @Action('app/setValue') private setValue: any;
  @Action('app/getQuotes') private getQuotes: any;
  @Action('quotation/reset') private resetQuotation: any;
  @Action('proposal/submitQuotes') private submitQuotes: any;
  @Action('proposal/incrementSaveProposalAttempts') private incrementSaveProposalAttempts: any;
  @Getter('quotation/getTotalQuotedPrice') private getTotalQuotedPrice!: () => number ;
  @Action('quotation/updateFactUpload') private updateFactUpload!: (proposalId?) => void;
  @Getter('quotation/getFactValueByFactID') private getFactValueByFactID!: (factID: string) => string;
  @Getter('quotation/isPriceValidByProductId') private isPriceValidByProductId!: (productID: string, isContinuation: boolean) => boolean;

  private addressCopies = {};

  get isEmptyQuotationProduct() {
    const quotedProductCount = Object.keys(this.quotation.products).length || 0;
    return quotedProductCount === 0 ? true : false;
  }

  get totalPrice() {
    return this.getTotalQuotedPrice() || '-';
  }

  get payButtonVisibility() {
    if (this.step.ref === 'payment') {
      return this.app.isPayButtonVisible;
    }
    return true;
  }

  private getImage(name) {
    return _.get(this.cms, 'theme.' + name, '');
  }

  private updateAddressCopies(addressCopies) {
    this.addressCopies = addressCopies;
  }

  private openPricebox() {
    EventBus.$emit('openPricebox');
  }

  private created() {
    window.onbeforeunload = () => {
      const component = this.step;
      if (component) {
        Util.gaLogStepperEvent(this, 'exit', component.ref);
      }
      return;
    };
  }

  private beforeDestroy() {
    window.onbeforeunload = () => {
      return;
    };
  }

  private scrollToError(errors: any) {
    this.$nextTick( () => {
      const el = document.querySelector('div.v-input.error--text,span.error--text') as HTMLElement;
      const ct = Util.findAncestor(el, '.v-expansion-panel-content');
      if (_.get(ct, 'style.display') === 'none') {
        ct.style.display = 'block';
      }
      if (el) {
        const top = (window.pageYOffset + el.getBoundingClientRect().top);
        window.scrollTo({behavior: 'smooth', left: 0, top: top - (this.$vuetify.breakpoint.height / 2)});
      }
    });
  }

  private getLabelForNext() {
    if (this.afterUW) {
      return this.$t(this.step.ref === 'summary' ? 'button.toPayment' : 'button.pay');
    }
    if (this.step.ref === 'summary') {
        const productsWithValidPrice = this.proposal.products
          .filter((product) => this.isPriceValidByProductId(product.id, false));

        if (productsWithValidPrice.length) {
          return this.$t('button.buyCover');
        } else {
          return this.$t('button.submitForReview');
        }
    }
    if (this.step.ref === 'payment') {
      return this.$t('button.pay');
    }
    return this.$t('button.nex');
  }

  get isBackVisible() {
    return this.step.ref !== 'payment' && !this.afterUW && (this.step.prev || !this.app.catalogueUrl);
  }

  get showTotal() {
    return this.step.ref === 'configure';
  }

  private async back() {
    const prevStep = this.step.prev;
    const component = this.step;
    if (component) {
      Util.gaLogStepperEvent(this, 'previous', component.ref);
    }
    if (prevStep) {
      this.$global.leaveAnimation();
      this.$emit('input', prevStep);
    } else {
      this.$router.push({name: 'landing'});
    }
  }

  private async next() {
    const value = this.step.ref;
    const component = this.getComponent(value);
    const step = this.getStep(component.ref);
    if (!step) {
      return;
    }
    const nextComponent = this.getComponent(this.step.next);
    const nextStep = nextComponent && this.getStep(nextComponent.ref);
    Util.gaLogStepperEvent(this, 'next', component.ref);
    setTimeout(() => {
      if (nextStep && _.isFunction(nextStep.beforeEnter)) {
        nextStep.beforeEnter();
      }
      if (_.isFunction(step.validate)) {
        step.validate();
      } else if (_.isFunction(step.submit)) {
        step.submit();
      } else {
        this.nextCallback();
      }
    }, 500);
  }

  private nextCallback() {
    const nextStep = this.step.next;
    if (nextStep) {
      this.$emit('input', nextStep);
    }
  }

  get footerVisibility() {
    return this.app.isFooterVisible;
  }

  private getComponent(ref: string) {
    return this.steps[ref];
  }

  private getStep(reference: any) {
    return _.isArray(this.$refs[reference]) ? this.$refs[reference][0] : this.$refs[reference];
  }

  get showSaveProposalButton() {
    return _.get(this.app, 'showSaveProposalButton', false) && this.app.activeStep === 5;
  }

  private async saveProposal() {
    this.incrementSaveProposalAttempts();
    const contactEmail = this.proposal.contactInfo.email;

    if (this.app.isRenewal && this.app.proposalId) {
      await this.getQuotes(this.app.proposalId);
    }
    if (contactEmail && this.proposal.saveProposalAttempts <= 3) {
      await this.submitQuotes({ sendEmail: true, generateDocument: true });
      this.updateFactUpload(this.proposal.proposalId);
      if (this.proposal.proposalId) {
        // this is necessary when just saved a proposal from a new session.
        this.setValue({code: 'proposalId', value: this.proposal.proposalId});
        this.$dialog.open({ type: 'saved-proposal', info: 'Saved proposal' });
      }
    }
  }
}
